export default __webpack_public_path__ + "static/random-sketch-d3d9a3e2a903a8e60ae735956d013ef4.jpg";